// Merkan · EAN/GTIN prüfen (GTIN-8, UPC-A, EAN-13, GTIN-14). Gleiche Regel wie app.gtin_gueltig in der Datenbank.

/** Nur Ziffern, Leerzeichen und Bindestriche entfernt */
export const gtinNormal = (s: string | null | undefined) => (s ?? '').replace(/[\s-]/g, '');

/** Prüfziffer nach GS1: von rechts ohne Prüfziffer abwechselnd mal 3 und mal 1 */
export function gtinPruefziffer(ohnePruefziffer: string): number {
  let summe = 0;
  for (let i = 0; i < ohnePruefziffer.length; i++) {
    const ziffer = Number(ohnePruefziffer[ohnePruefziffer.length - 1 - i]);
    summe += ziffer * (i % 2 === 0 ? 3 : 1);
  }
  return (10 - (summe % 10)) % 10;
}

export function gtinPruefen(s: string | null | undefined): { ok: boolean; grund?: 'laenge' | 'ziffern' | 'pruefziffer' } {
  const g = gtinNormal(s);
  if (!/^\d+$/.test(g)) return { ok: false, grund: 'ziffern' };
  if (![8, 12, 13, 14].includes(g.length)) return { ok: false, grund: 'laenge' };
  return gtinPruefziffer(g.slice(0, -1)) === Number(g.slice(-1)) ? { ok: true } : { ok: false, grund: 'pruefziffer' };
}

/** Sieht der Code wie ein Artikel-Barcode aus (nur Ziffern in GTIN-Länge mit gültiger Prüfziffer)? */
export const istGtin = (s: string) => gtinPruefen(s).ok;
